import { Outlet } from 'react-router-dom'
import { Skeleton } from '@/components/ui/skeleton'
import { BlockedState } from '@/components/shared/BlockedState'
import { useCompanies, useActiveCompanyId } from '@/lib/queries/companies'

export function RequireCompany() {
  const { isLoading, data: companies } = useCompanies()
  const activeCompanyId = useActiveCompanyId()

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 p-8">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-32 w-full" />
      </div>
    )
  }

  if (!companies || companies.length === 0) {
    return (
      <BlockedState
        title="Nenhuma company encontrada"
        description="Crie uma company para começar a usar o plano de controle."
      />
    )
  }

  if (!activeCompanyId) {
    return (
      <BlockedState
        title="Nenhuma company selecionada"
        description="Selecione uma company no seletor no topo da tela para continuar."
      />
    )
  }

  return <Outlet />
}
